import { render, staticRenderFns } from "./Income.vue?vue&type=template&id=2e65ec3a&scoped=true&"
import script from "./Income.vue?vue&type=script&lang=js&"
export * from "./Income.vue?vue&type=script&lang=js&"
import style0 from "./Income.vue?vue&type=style&index=0&id=2e65ec3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e65ec3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e65ec3a')) {
      api.createRecord('2e65ec3a', component.options)
    } else {
      api.reload('2e65ec3a', component.options)
    }
    module.hot.accept("./Income.vue?vue&type=template&id=2e65ec3a&scoped=true&", function () {
      api.rerender('2e65ec3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/Income.vue"
export default component.exports